import React from 'react';
import styled from 'styled-components';
import { gray90, spacer48 } from '@spotify-internal/encore-foundation';
import { PodcastSettings } from '../PodcastSettings';
import { PodcastShare } from '../PodcastShare';
import { useMe } from '../../../hooks/useMe';
import { PodcastInfo } from './PodcastInfo';
import { Trailer } from '../../../types';

interface Props {
  licensor: string;
  networkId: string;
  feedUrl: string;
  hasNetworkPermissions: boolean;
  podcastId: string;
  toggleTrailerSelectionModal: () => void;
  updateSelectedTrailer: (trailer: Trailer | null) => void;
  trailer?: Trailer;
  isTaxiFeed?: boolean;
}

export function PodcastDetails(props: Props) {
  const me = useMe()!;

  return (
    <>
      <PodcastInfo
        toggleTrailerSelectionModal={props.toggleTrailerSelectionModal}
        updateSelectedTrailer={props.updateSelectedTrailer}
        trailer={props.trailer}
        podcastId={props.podcastId}
      />

      <PodcastDetailsSection>
        <PodcastShare podcastId={props.podcastId} />
      </PodcastDetailsSection>
      <PodcastDetailsSection>
        <PodcastSettings
          licensor={props.licensor}
          networkId={props.networkId}
          feedUrl={props.feedUrl}
          showId={props.podcastId}
          hasNetworkPermissions={props.hasNetworkPermissions}
          isTaxiFeed={props.isTaxiFeed}
        />
      </PodcastDetailsSection>
    </>
  );
}

const PodcastDetailsSection = styled.div`
  border-top: 1px solid ${gray90};
  padding-top: ${spacer48};
  margin-bottom: ${spacer48};
`;
